import { useState } from "react";
import { Icon } from "@/components/Icons";
import type { AccountPattern } from "../types";

/**
 * Account pattern banner (Reskin Session C). Orange-tinted banner plus an
 * expandable panel of the other active signals at this account (each linking to
 * its canonical signal route) and a quiet prior-engagement line. Renders nothing
 * if no pattern relates. Read projection only; the SCF score is never blended.
 */
export function AccountPatternBanner({
  pattern,
}: {
  pattern: AccountPattern | null;
}): JSX.Element | null {
  const [open, setOpen] = useState(false);
  if (!pattern || pattern.activeCount <= 0) return null;

  return (
    <div className="sxr-pattern">
      <p className="sxr-pattern-lead">
        <Icon name="network" />
        {pattern.activeCount} active signals at {pattern.company} this quarter
      </p>
      <button
        type="button"
        className="sxr-pattern-expand"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        View related signals
        <Icon name="chevron-down" />
      </button>
      {open ? (
        <div className="sxr-pattern-panel">
          {pattern.related.map((r) => (
            <a key={r.id} className="sxr-related-row" href={`/signals/${r.id}`}>
              <span className="sxr-related-score">{r.score}</span>
              <span className="sxr-related-headline">{r.headline}</span>
            </a>
          ))}
          {pattern.priorEngagement ? (
            <p className="sxr-related-prior">{pattern.priorEngagement}</p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
